import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String,
  };
  change(event) {
    const value = event.target.value;
    const elementName = event.target.name;
    const params = new URLSearchParams();
    params.append(elementName, value);

    patch(`${this.urlValue}?${params}`, {
      responseKind: "turbo-stream",
    });
  }
}
